import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthorizationService } from '@mirage-projects/cw-commons';

@Injectable({
    providedIn: 'root',
})
export class HomeGuard {
    constructor(
        private authorizationService: AuthorizationService,
        private router: Router
    ) {}

    canActivate(): boolean {
        if (this.authorizationService.isUserLogged()) {
            this.router.navigate(['/']);

            return false;
        }

        return true;
    }
}
